document.addEventListener('DOMContentLoaded', initializePage);

// console.log('Sidebar JS loaded');

function initializePage() {
  setupSidebarToggle();
  setupSidebarClose();
  setupAccordions();
}

function setupSidebarToggle() {
  const sidebar = document.querySelector('#sidebar');
  const hamBurger = document.querySelector('#menu-toggler');

  if (hamBurger) {
    hamBurger.addEventListener('click', function (event) {
      sidebar.classList.toggle('active');
      event.stopPropagation();
    });
  }
}

function setupSidebarClose() {
  const sidebar = document.querySelector('#sidebar');
  const closeButton = document.querySelector('.btn-close');
  document.addEventListener('click', function (event) {
    if (sidebar && !sidebar.contains(event.target) && sidebar.classList.contains('active')) {
      sidebar.classList.remove('active');
    }
  });

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      sidebar.classList.remove('active');
    });
  }
}

window.setupAccordions = function setupAccordions() {
  // Using event delegation
  document.body.addEventListener('click', function (event) {
    const button = event.target.closest('.accordion-button');
    if (button) {
      toggleAccordion.call(button);
    }
  });
};

window.toggleAccordion = function toggleAccordion() {
  const isExpanded = this.getAttribute('aria-expanded') === 'true';
  const control = this.getAttribute('aria-controls');
  const collapseElement = document.getElementById(control);

  // Log the current state before toggling
  console.log('Before toggling - Accordion button class:', this.className);
  console.log('Before toggling - MENU content class:', collapseElement.className);

  if (collapseElement) {
    this.setAttribute('aria-expanded', !isExpanded);
    collapseElement.classList.toggle('active'); // Toggle the 'active' class

    // Add 'collapsed' if the element is being closed, remove if it's being opened.
    if (isExpanded) {
      this.classList.add('collapsed');
      this.classList.remove('active');
    } else {
      this.classList.remove('collapsed');
      this.classList.add('active');
    }

    // Log the updated state after toggling
    console.log('After toggling - MENU content class:', collapseElement.className);
    console.log('After click - Accordion button class:', this.className);
  } else {
    console.error('Collapse element not found:', control);
  }
};

document.addEventListener('turbo:load', setupAccordions);
document.addEventListener('turbo:load', setupAccordions);
